import { ApolloQueryResult } from '@apollo/client';

import { User, UserCreateInput } from '@topconagriculture/frontend-utils';
import { graphqlClient } from '@topconagriculture/graphql-client';

import * as COMPANY_CREATE_USER from './gql/company.create.user.gql';
import { API_CLIENTS } from '../../../config/constants';

export const createCompanyUser = (user: UserCreateInput): Promise<ApolloQueryResult<User>> => {
  return graphqlClient
    .getClient(API_CLIENTS.graphqlClient)
    .mutate<User>({
      mutation: COMPANY_CREATE_USER,
      variables: {
        user,
      },
    })
    .then((response: any) => {
      return response.data;
    });
};
